module.exports = __webpack_public_path__ + "static/img/y14.2233111.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/view/images/y14.jpg
// module id = iZRt
// module chunks = 1